// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `
.navbar-container {
    min-width: 100%;
    display: flex;
    justify-content: space-around;
    align-items: center;
}

.navbar-nav .nav-item {
    background: none;
    margin-right: 8px;
    border-radius: 3px;
    width: auto;
    padding-right: 12px;
    padding-left: 12px;
    display: flex;
    justify-content: center;
    align-items: center;
    transition: 0.17s;
    color: rgba(255,255,255,.5);
    cursor: pointer;
    position: relative;
}

.navbar-nav .nested.nav-item {
    display: none;
}

.navbar-nav .nav-item.active {
    background-color: rgba(200,200,200,0.2);
    transform: scale(1.1,1.1);
    color: white;
}

.navbar-nav .nav-item:hover {
    background-color: rgba(200,200,200,0.1);
    transform: scale(1.1,1.1);
    transition: 0.17s;
    color: rgba(255,255,255,.75);
}

.navbar-nav .nav-item.active:hover {
    background-color: rgba(200,200,200,0.2);
    transform: scale(1.1,1.1);
}

.nav-menu {
    display: none;
    height: 40px;
    width: 40px;
    justify-content: center;
    align-items: center;
}

.navbar-nav-mobile {
    display: none;
}

.navbar-nav .nav-item.nest {
    z-index: 999 !important;
}

.navbar-nav .nav-item.nest:hover {
    z-index: 999 !important;
}

.sublist {
    display: none;
    list-style: none;
    z-index: 999 !important;
}

.sublist.active {
    display: block;
    position: absolute;
    top: 45px;
    left: 0;
    color: black;
    z-index: 999 !important;
    padding: 5px 0 10px 0;
    /* max-width: 130px; */
    white-space: nowrap; 
    background-color: rgba(220,220,220,1);
}

.sublist.active .nested-li {
    z-index: 999 !important;
}

.sublist.active .nested-li:hover {
    background-color: rgba(160,160,160,1);
    z-index: 999 !important;
}

.sublist.active .nested-li .nav-link {
    color: black;
    z-index: 999 !important;
}

.about {
    margin-top: 40px;
}

@media only screen and (max-width: 1000px) {
    body {
        overflow-x:hidden;
        min-width: 100%;
    }
    .navbar {
        z-index: 11;
    }
    .navbar-nav {
        display: none;
    }

    .navbar-nav-mobile {
        display: flex;
        flex-direction: column;
        background-color: rgb(124, 143, 163);
        width: 100%;
        height: auto;
        list-style: none;
        position: absolute;
        top: -640px;
        left: 0;
        z-index: 10;
        transition: 0.6s;
        padding: 8px 0;
        margin: 0;
    }

    .navbar-nav-mobile.active {
        top: 56px;
        left: 0;
        transition: 0.6s;
    }

    .nav-link {
        padding-left: 0;
    }

    .navbar-nav-mobile .nav-item {
        width: 90%;
        margin: 2px 5%;
        box-sizing: border-box;
        display: flex;
        justify-content: flex-start;
        align-items: center;
        min-height: 60px;
        cursor: pointer;
        color: rgba(255,255,255,1);
        padding-left: 16px;
    }

    .navbar-nav-mobile .nested.nav-item {
        display: none;
    }

    .navbar-nav-mobile .nested.nav-item.active {
        width: 90%;
        margin: 2px 5%;
        box-sizing: border-box;
        display: flex;
        justify-content: flex-start;
        align-items: center;
        min-height: 60px;
        cursor: pointer;
        color: rgba(255,255,255,1);
        padding-left: 48px;
        transition: ease-in-out;
    }

    .navbar-nav-mobile .nav-item a:hover {
        background-color: rgba(200,200,200,0.1);
    }

    .navbar-nav-mobile .nav-item a {
        color: white;
        font-size: 16px;
        min-width: 100%;
        min-height: 100%;
        line-height: 20px;
        padding-top: 20px;
        padding-bottom: 20px;
        padding: auto;     
    }

    .nav-menu {
        display: flex;
        color: white;
        font-size: 32px;
        position: absolute;
        top: 8px;
        right: 16px;
        cursor: pointer;
        border-radius: 3px;
    }

    .nav-menu:hover {
        background-color: rgba(200,200,200,0.1);
    }
}`, "",{"version":3,"sources":["webpack://./src/component_css/NavBar.css"],"names":[],"mappings":";AACA;IACI,eAAe;IACf,aAAa;IACb,6BAA6B;IAC7B,mBAAmB;AACvB;;AAEA;IACI,gBAAgB;IAChB,iBAAiB;IACjB,kBAAkB;IAClB,WAAW;IACX,mBAAmB;IACnB,kBAAkB;IAClB,aAAa;IACb,uBAAuB;IACvB,mBAAmB;IACnB,iBAAiB;IACjB,2BAA2B;IAC3B,eAAe;IACf,kBAAkB;AACtB;;AAEA;IACI,aAAa;AACjB;;AAEA;IACI,uCAAuC;IACvC,yBAAyB;IACzB,YAAY;AAChB;;AAEA;IACI,uCAAuC;IACvC,yBAAyB;IACzB,iBAAiB;IACjB,4BAA4B;AAChC;;AAEA;IACI,uCAAuC;IACvC,yBAAyB;AAC7B;;AAEA;IACI,aAAa;IACb,YAAY;IACZ,WAAW;IACX,uBAAuB;IACvB,mBAAmB;AACvB;;AAEA;IACI,aAAa;AACjB;;AAEA;IACI,uBAAuB;AAC3B;;AAEA;IACI,uBAAuB;AAC3B;;AAEA;IACI,aAAa;IACb,gBAAgB;IAChB,uBAAuB;AAC3B;;AAEA;IACI,cAAc;IACd,kBAAkB;IAClB,SAAS;IACT,OAAO;IACP,YAAY;IACZ,uBAAuB;IACvB,qBAAqB;IACrB,sBAAsB;IACtB,mBAAmB;IACnB,qCAAqC;AACzC;;AAEA;IACI,uBAAuB;AAC3B;;AAEA;IACI,qCAAqC;IACrC,uBAAuB;AAC3B;;AAEA;IACI,YAAY;IACZ,uBAAuB;AAC3B;;AAEA;IACI,gBAAgB;AACpB;;AAEA;IACI;QACI,iBAAiB;QACjB,eAAe;IACnB;IACA;QACI,WAAW;IACf;IACA;QACI,aAAa;IACjB;;IAEA;QACI,aAAa;QACb,sBAAsB;QACtB,oCAAoC;QACpC,WAAW;QACX,YAAY;QACZ,gBAAgB;QAChB,kBAAkB;QAClB,WAAW;QACX,OAAO;QACP,WAAW;QACX,gBAAgB;QAChB,cAAc;QACd,SAAS;IACb;;IAEA;QACI,SAAS;QACT,OAAO;QACP,gBAAgB;IACpB;;IAEA;QACI,eAAe;IACnB;;IAEA;QACI,UAAU;QACV,cAAc;QACd,sBAAsB;QACtB,aAAa;QACb,2BAA2B;QAC3B,mBAAmB;QACnB,gBAAgB;QAChB,eAAe;QACf,0BAA0B;QAC1B,kBAAkB;IACtB;;IAEA;QACI,aAAa;IACjB;;IAEA;QACI,UAAU;QACV,cAAc;QACd,sBAAsB;QACtB,aAAa;QACb,2BAA2B;QAC3B,mBAAmB;QACnB,gBAAgB;QAChB,eAAe;QACf,0BAA0B;QAC1B,kBAAkB;QAClB,uBAAuB;IAC3B;;IAEA;QACI,uCAAuC;IAC3C;;IAEA;QACI,YAAY;QACZ,eAAe;QACf,eAAe;QACf,gBAAgB;QAChB,iBAAiB;QACjB,iBAAiB;QACjB,oBAAoB;QACpB,aAAa;IACjB;;IAEA;QACI,aAAa;QACb,YAAY;QACZ,eAAe;QACf,kBAAkB;QAClB,QAAQ;QACR,WAAW;QACX,eAAe;QACf,kBAAkB;IACtB;;IAEA;QACI,uCAAuC;IAC3C;AACJ","sourcesContent":["\n.navbar-container {\n    min-width: 100%;\n    display: flex;\n    justify-content: space-around;\n    align-items: center;\n}\n\n.navbar-nav .nav-item {\n    background: none;\n    margin-right: 8px;\n    border-radius: 3px;\n    width: auto;\n    padding-right: 12px;\n    padding-left: 12px;\n    display: flex;\n    justify-content: center;\n    align-items: center;\n    transition: 0.17s;\n    color: rgba(255,255,255,.5);\n    cursor: pointer;\n    position: relative;\n}\n\n.navbar-nav .nested.nav-item {\n    display: none;\n}\n\n.navbar-nav .nav-item.active {\n    background-color: rgba(200,200,200,0.2);\n    transform: scale(1.1,1.1);\n    color: white;\n}\n\n.navbar-nav .nav-item:hover {\n    background-color: rgba(200,200,200,0.1);\n    transform: scale(1.1,1.1);\n    transition: 0.17s;\n    color: rgba(255,255,255,.75);\n}\n\n.navbar-nav .nav-item.active:hover {\n    background-color: rgba(200,200,200,0.2);\n    transform: scale(1.1,1.1);\n}\n\n.nav-menu {\n    display: none;\n    height: 40px;\n    width: 40px;\n    justify-content: center;\n    align-items: center;\n}\n\n.navbar-nav-mobile {\n    display: none;\n}\n\n.navbar-nav .nav-item.nest {\n    z-index: 999 !important;\n}\n\n.navbar-nav .nav-item.nest:hover {\n    z-index: 999 !important;\n}\n\n.sublist {\n    display: none;\n    list-style: none;\n    z-index: 999 !important;\n}\n\n.sublist.active {\n    display: block;\n    position: absolute;\n    top: 45px;\n    left: 0;\n    color: black;\n    z-index: 999 !important;\n    padding: 5px 0 10px 0;\n    /* max-width: 130px; */\n    white-space: nowrap; \n    background-color: rgba(220,220,220,1);\n}\n\n.sublist.active .nested-li {\n    z-index: 999 !important;\n}\n\n.sublist.active .nested-li:hover {\n    background-color: rgba(160,160,160,1);\n    z-index: 999 !important;\n}\n\n.sublist.active .nested-li .nav-link {\n    color: black;\n    z-index: 999 !important;\n}\n\n.about {\n    margin-top: 40px;\n}\n\n@media only screen and (max-width: 1000px) {\n    body {\n        overflow-x:hidden;\n        min-width: 100%;\n    }\n    .navbar {\n        z-index: 11;\n    }\n    .navbar-nav {\n        display: none;\n    }\n\n    .navbar-nav-mobile {\n        display: flex;\n        flex-direction: column;\n        background-color: rgb(124, 143, 163);\n        width: 100%;\n        height: auto;\n        list-style: none;\n        position: absolute;\n        top: -640px;\n        left: 0;\n        z-index: 10;\n        transition: 0.6s;\n        padding: 8px 0;\n        margin: 0;\n    }\n\n    .navbar-nav-mobile.active {\n        top: 56px;\n        left: 0;\n        transition: 0.6s;\n    }\n\n    .nav-link {\n        padding-left: 0;\n    }\n\n    .navbar-nav-mobile .nav-item {\n        width: 90%;\n        margin: 2px 5%;\n        box-sizing: border-box;\n        display: flex;\n        justify-content: flex-start;\n        align-items: center;\n        min-height: 60px;\n        cursor: pointer;\n        color: rgba(255,255,255,1);\n        padding-left: 16px;\n    }\n\n    .navbar-nav-mobile .nested.nav-item {\n        display: none;\n    }\n\n    .navbar-nav-mobile .nested.nav-item.active {\n        width: 90%;\n        margin: 2px 5%;\n        box-sizing: border-box;\n        display: flex;\n        justify-content: flex-start;\n        align-items: center;\n        min-height: 60px;\n        cursor: pointer;\n        color: rgba(255,255,255,1);\n        padding-left: 48px;\n        transition: ease-in-out;\n    }\n\n    .navbar-nav-mobile .nav-item a:hover {\n        background-color: rgba(200,200,200,0.1);\n    }\n\n    .navbar-nav-mobile .nav-item a {\n        color: white;\n        font-size: 16px;\n        min-width: 100%;\n        min-height: 100%;\n        line-height: 20px;\n        padding-top: 20px;\n        padding-bottom: 20px;\n        padding: auto;     \n    }\n\n    .nav-menu {\n        display: flex;\n        color: white;\n        font-size: 32px;\n        position: absolute;\n        top: 8px;\n        right: 16px;\n        cursor: pointer;\n        border-radius: 3px;\n    }\n\n    .nav-menu:hover {\n        background-color: rgba(200,200,200,0.1);\n    }\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
